import { motion } from 'framer-motion';

const blobVariants = {
  animate: index => ({
    x: [0, index % 2 === 0 ? 48 : -36, 0],
    y: [0, index % 2 === 0 ? -32 : 26, 0],
    scale: [1, 1.06, 1],
    transition: {
      duration: 20 + index * 4,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut',
    },
  }),
};

const blobs = [
  {
    id: 'teal',
    className:
      'absolute -top-24 -left-24 h-[38rem] w-[38rem] rounded-full bg-teal-500/40 blur-2xl dark:bg-teal-400/35',
  },
  {
    id: 'lime',
    className:
      'absolute -bottom-32 -right-24 h-[34rem] w-[34rem] rounded-full bg-lime-400/30 blur-2xl dark:bg-lime-300/25',
  },
];

export default function BackgroundFX() {
  return (
    <motion.div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-white/70 to-slate-200/40 dark:from-slate-950 dark:via-slate-900/90 dark:to-slate-900/60" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(20,184,166,0.18),transparent_60%)] dark:bg-[radial-gradient(circle_at_top_left,rgba(20,184,166,0.12),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(132,204,22,0.15),transparent_65%)] dark:bg-[radial-gradient(circle_at_bottom_right,rgba(132,204,22,0.14),transparent_65%)]" />
      <div className="absolute inset-0 opacity-40 mix-blend-soft-light bg-[radial-gradient(rgba(148,163,184,0.18)_1px,transparent_1px)] [background-size:20px_20px]" />
      {blobs.map((blob, index) => (
        <motion.div
          key={blob.id}
          className={blob.className}
          variants={blobVariants}
          animate="animate"
          custom={index}
        />
      ))}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(0,0,0,0.35)_100%)]" />
    </motion.div>
  );
}
